import { render } from "./closeTicket.vue?vue&type=template&id=0226c893"
import script from "./closeTicket.vue?vue&type=script&lang=js"
export * from "./closeTicket.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__